/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BuilderNavigationService,
  BuilderUserContext,
  FilterRestService,
} from '@gh/builder-shared';
import { BuilderPermissionSet, ContactType, SystemRoleBit } from '@gh/builder-shared-data';
import { AppRouter, EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { filterTracker, RouteDataService, SlicedDataSource } from '@gh/core-data';
import { DialogService, NotificationService } from '@gh/core-ui';
import { cursorTracker, newGridPaginationCursor } from '@gh/core-ui-grid';
import { assign } from 'lodash';
import { ContactListBusinessService } from '../../resources/contact-list-business.service';
import { ContactListFilterViewMapper } from '../../resources/contact-list-filter.model';
import { ContactListInit } from '../../resources/contact-list-init.model';
import { ContactListItem } from '../../resources/contact-list-item.model';
import { ContactGridDefinition } from './contact-grid-definition.service';
import { ContactListFormState } from './contact-list-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-list',
  templateUrl: 'contact-list.component.html',
  styleUrls: ['contact-list.component.scss'],
  viewProviders: [
    ContactListFormState,
    ContactGridDefinition,
  ],
})
export class ContactListComponent implements OnInit {
  init: ContactListInit;
  contactTypes: EnumDictionary<ContactType>;

  dataSource: SlicedDataSource<ContactListItem>;
  cursor = newGridPaginationCursor();

  get isValidateAvailable(): boolean {
    return this.userContext.officeView && (this.userContext.hasSystemRole(SystemRoleBit.Corporate)
      || this.userContext.hasSystemRole(SystemRoleBit.Master)
      || this.userContext.hasPermission(BuilderPermissionSet.Contacts.Details.CREATE_EDIT));
  }
  constructor(private route: ActivatedRoute,
              private userContext: BuilderUserContext,
              private dialogs: DialogService,
              public form: ContactListFormState,
              private businessService: ContactListBusinessService,
              private router: AppRouter,
              private navigationService: BuilderNavigationService,
              private routeData: RouteDataService,
              private filterService: FilterRestService,
              private notificationService: NotificationService,
              public gridDefinition: ContactGridDefinition) {

  }

  ngOnInit(): void {
    const {filter: initFilter, filterName, gridLayout, ...init } = getRouteInitData(this.route);
    let isInit = true;
    assign(this, init);

    this.gridDefinition.bind(gridLayout);

    this.form.build(initFilter, init.init.options);

    const tracker = this.routeData
      .tracker(filterTracker(this.form, ContactListFilterViewMapper))
      .withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(([filter]) => {
      this.dataSource = this.businessService.findAllAsDataSource(filter, this.init);
      if (!isInit) {
        this.filterService.update(filterName,  {...filter, name: ''}).subscribe(() => {}, this.notificationService.processAll);
      }
      isInit = false;
    });
  }

  onCreate(): void {
    this.router.navigateToChild(['/contacts/new'], {
      parentTitle: 'lbl_menu_contacts',
    });
  }

  onEdit(contact: ContactListItem): void {
    if (this.userContext.hasPermission(BuilderPermissionSet.Contacts.Details.ANY)) {
      this.router.navigateToChild(['/contacts', contact.id], {
        parentTitle: 'lbl_menu_contacts',
      });
    }
  }

  goToAel(contact?: ContactListItem): void {
    this.navigationService.goToAel({
      label: 'lbl_menu_contacts',
      entityType: 'CONTACT',
      entityId: contact ? contact.id : undefined,
    });
  }

  onSearch(): void {
    this.form.emitFilter();
  }

  validate(contact: ContactListItem): void {
    this.businessService.validate(contact.id).subscribe(() => {
      this.notificationService.success('msg_validate_contact_google_folders_task_added', {contactName: contact.name});
    },                                                  (error) => {
      this.notificationService.processAll(error);
    });
  }

  findAllDuplicates(): void {
    this.router.navigateToChild(['/contacts/duplicates'], {
      parentTitle: 'lbl_menu_contacts',
    });
  }
}
